import styled from "styled-components";


export const Container = styled.div`
    align-items: flex-start;
    background: transparent;
    border-radius: 10px;
    display: ${({$Active})=> ($Active ? 'flex' : 'none')};
    flex-grow: 1;
    justify-content: center;
    margin-top: 80px;
    max-height: 100vh;
    padding: 6px 0;
    position: fixed;
    // opacity: 0.8;
    right: 10px;
    transition: ease-out 0.8s;
    width: 380px;
    z-index: 999;
    @media (max-width: 1000px) {
        display: none;
    }
`;

export const ContentContainer = styled.div`
    align-items: center;
    background: #D9D9D9;
    border-radius: 10px;
    display: flex;
    flex-direction: column;
    gap: 10px;
    max-height: 90vh;
    padding: 20px 0;
    position: relative;
    width: 100%;
`;

export const TitleContainer = styled.div`
    align-items: center;
    background: ${({ $background }) => $background ? $background : '#F6F6F6'};
    border-radius: 2.5px;
    box-shadow: 1.461px 1.461px 0px 0px rgba(0, 0, 0, 0.25);
    display: flex;
    height: max-content;
    justify-content: center;
    min-height: 65.739px;
    width: 100%;
`;

export const Title = styled.h1`
    color: ${({ $background }) => $background ? '#FFF' : '#333'};
    font-size: 18px;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
    text-align: center;
`;

export const ChildsContainer = styled.div`
    align-items: center;
    display: flex;
    flex-direction: column;
    gap: 15px;
    height: 100%;
    overflow: auto;
    padding: 10px;
    width: 100%;
    &::-webkit-scrollbar {
        width : 3px;
    }
    &::-webkit-scrollbar-thumb {
        background-color: #ccc;
        border-radius: 5px;
    }
    &::-webkit-scrollbar-thumb:hover {
        background-color: #aaa
    }
    &::-webkit-scrollbar-track {
        background: transparent;
    }
    &::-webkit-scrollbar-button {
        display: none;
    }
`;

export const RemoveAllButton = styled.button`
    align-items: center;
    background: transparent;
    border: 1px solid #006560;
    border-radius: 2.5px;
    color: #333;
    cursor: pointer;
    display: flex;
    justify-content: center;
    font-size: 15px;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
    outline: none;
    padding: 15px;
    transition: 0.5s;
    width: fit-content;
    &:hover{
        background: #006560;
        color: #FFF;
    }
`;